define("shared/utils/formatters/ig-user-from-instagram", ["exports", "later/models/ig-user"], function (_exports, _igUser) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"later/models/ig-user"eaimeta@70e063a35619d71f

  function createIgUserFromInstagram(obj, socialProfile) {
    const attrs = {};
    attrs.socialProfile = socialProfile;
    attrs.id = obj.id;
    attrs.username = obj.username;
    attrs.fullName = obj.full_name ? obj.full_name : null;
    attrs.profilePictureUrl = obj.profile_picture ? obj.profile_picture : null;
    attrs.bio = obj.bio ? obj.bio : null;
    attrs.website = obj.website ? obj.website : null;
    attrs.mediaCount = obj.media_count ? obj.media_count : null;

    if (obj.counts) {
      attrs.mediaCount = obj.counts.media;
      attrs.followsCount = obj.counts.follows;
      attrs.followedByCount = obj.counts.followed_by;
    }

    return _igUser.default.create(attrs);
  }

  var _default = createIgUserFromInstagram;
  _exports.default = _default;
});